// Module
var code = "<div class=\"Tappable-inactive availabilities-slot slot-available\" tabindex=\"0\" role=\"button\"> 09:30 </div>";
// Exports
module.exports = code;